export class Constants {


    static locationId = ""
    static customerId = "";
    static strPalletId = "";
    static dcId = "";
    static DC_MODE = "edge";
    static DC_MODE_EDGE = "edge"
    static DC_MODE_CLOUD = "cloud"
    static RPC_ADMIN = "RpcAdmin"
    static RPC_READ_ONLY = "RpcReadOnly"
    static PORTRAIT = "portrait";
    static LANDSCAPE = "landscape";
    static isAuditLoaded = false;

    static MISSING = "Missing";
    static EXTRA = "Extra";
    static CAN_NOT_CONFIRM = "Can’t confirm";
    static AUDITED = "Audited";
    static NO_ERROR = "No error";
    static UN_TRAINED = "UNTRAINED";
    static SCREEN_NAME = "";
    static PALLET_REVIEW = "PalletReview";
    static PALLET_ARCHIVE = "PalletArchive";

    static PANEL_SIDE1 = "side1";
    static PANEL_SIDE2 = "side2";
    static PANEL_SIDE3 = "side3";
    static PANEL_SIDE4 = "side4"
    static PANEL_DATE_FMT = "MM-DD-YYYY HH:mm:ss"

    static palletArchiveData = []

    static IS_IMAGE_CORRECTION_ENABLED = false;
    static IS_PROCESS_ERROR_REASONS_ENABLED = false;
    static IS_PALLET_REVIEW_REFRESH = false;
    static userId = ""

    static userRole = "";
    static userApps = "";

    static ROUTE_SELECTION_EVENT = "ROUTE_SELECTION_EVENT";
    static ROUTE_DETAILS_BACK_EVENT = "ROUTE_DETAILS_BACK_EVENT";
    static ASSET_HANDLE_CLICK_EVENT = "ASSET_HANDLE_CLICK_EVENT";
    static SELECT_DATE = null;
    static ROUTE_IN_PROGRESS = "In progress";
    static ROUTE_IN_COMPLETED = "Completed";
    static STICHING_VIEWER = "";
    static RECT_NO_CHANGE = "nochange";
    static RECT_UPDATE = "update";
    static RECT_DELETE = "delete";
    static RECT_NEW = "new";

    static REACT_UNASSIGNED = "unassigned"

    static SKU_FILE_DATA = {}

    static WORK_ITEMS_DATA = {
        "manual_labeled_pallet_id": 1,
        "customer_id": 11,
        "dc_id": 8,
        "customer_picklist_id": "6806148",
        "delivery_date": "2026-01-22",
        "status": "APPROVED",
        "priority": 10,
        "is_system_recommended": true,
        "is_llm_labeled": false,
        "is_modified_after_llm_labeled": false,
        "labeled_by": "user-xyz",
        "label_completion_date": "2026-02-23T12:55:59.476000",
        "reviewed_by": "Admin",
        "review_completion_date": null,
        "store_name": "SHANS",
        "store_number": "5567",
        "contains_un_trained_sku": true,
        "is_picker_err": false,
        "is_qc_bot_audited": false,
        "bounding_boxes_json": {
          "body": {
            "errors": [],
            "matchingItems": [
              {
                "product": "018200250064",
                "vor_reference_number": "100819",
                "quantity": 1,
                "description": "Bud Ice 15/25 Can",
                "packages_per_case": 1,
                "is_unverifiable_sku": false,
                "outOfStockStatus": 0,
                "quantity_ordered": 1,
                "customer_sku_id": 2525
              },
              {
                "product": "018200250019",
                "vor_reference_number": "101012",
                "quantity": 2,
                "description": "Bud Light 15/25 Can",
                "packages_per_case": 1,
                "is_unverifiable_sku": false,
                "outOfStockStatus": 0,
                "quantity_ordered": 2,
                "customer_sku_id": 2535
              },
              {
                "product": "018200255083",
                "vor_reference_number": "100812",
                "quantity": 1,
                "description": "Bud Light Chelada 15/25 Can",
                "packages_per_case": 1,
                "is_unverifiable_sku": false,
                "outOfStockStatus": 0,
                "quantity_ordered": 1,
                "customer_sku_id": 2550
              },
              {
                "product": "018200250040",
                "vor_reference_number": "100110",
                "quantity": 1,
                "description": "Busch Light 15/25 Can",
                "packages_per_case": 1,
                "is_unverifiable_sku": false,
                "outOfStockStatus": 0,
                "quantity_ordered": 1,
                "customer_sku_id": 2635
              },
              {
                "product": "018200250088",
                "vor_reference_number": "100824",
                "quantity": 1,
                "description": "Natural Ice 15/25 Can",
                "packages_per_case": 1,
                "is_unverifiable_sku": false,
                "outOfStockStatus": 0,
                "quantity_ordered": 1,
                "customer_sku_id": 2951
              },
              {
                "product": "018200250026",
                "vor_reference_number": "100855",
                "quantity": 1,
                "description": "Natural Light 15/25 Can",
                "packages_per_case": 1,
                "is_unverifiable_sku": false,
                "outOfStockStatus": 0,
                "quantity_ordered": 1,
                "customer_sku_id": 2955
              },
              {
                "product": "018200250101",
                "vor_reference_number": "101015",
                "quantity": 1,
                "description": "Ultra 15/25 Can",
                "packages_per_case": 1,
                "is_unverifiable_sku": false,
                "outOfStockStatus": 0,
                "quantity_ordered": 1,
                "customer_sku_id": 3136
              },
              {
                "product": "018200239861",
                "vor_reference_number": "400545",
                "quantity": 2,
                "description": "375 ULTRA 3/8/16 CAN",
                "packages_per_case": 1,
                "is_unverifiable_sku": false,
                "outOfStockStatus": 0,
                "quantity_ordered": 2,
                "customer_sku_id": 3982
              },
              {
                "product": "01853229",
                "vor_reference_number": "402148",
                "quantity": 1,
                "description": "3842 HURRICANE HIGH GRAVITY 6/4/16 CAN",
                "packages_per_case": 1,
                "is_unverifiable_sku": false,
                "outOfStockStatus": 0,
                "quantity_ordered": 1,
                "customer_sku_id": 5585
              },
              {
                "product": "01853724",
                "vor_reference_number": "402261",
                "quantity": 1,
                "description": "91 BUDWEISER 6/4/16 CAN",
                "packages_per_case": 1,
                "is_unverifiable_sku": false,
                "outOfStockStatus": 0,
                "quantity_ordered": 1,
                "customer_sku_id": 5698
              },
              {
                "product": "684746355107",
                "vor_reference_number": "402375",
                "quantity": 2,
                "description": "2998 JOHNY BOOTLEGGER RASPBERRY 24/200 BOTTLE",
                "packages_per_case": 1,
                "is_unverifiable_sku": false,
                "outOfStockStatus": 0,
                "quantity_ordered": 2,
                "customer_sku_id": 5785
              },
              {
                "product": "849806002272",
                "vor_reference_number": "405094",
                "quantity": 1,
                "description": "9769 FOUR LOKO SOUR BLUE RAZZ 12/23.5 CAN",
                "packages_per_case": 1,
                "is_unverifiable_sku": false,
                "outOfStockStatus": 0,
                "quantity_ordered": 1,
                "customer_sku_id": 8417
              },
              {
                "product": "684746403501",
                "vor_reference_number": "1844961",
                "quantity": 1,
                "description": "10098 CLUBTAILS GRAPE ESCAPE 24/16 CAN",
                "packages_per_case": 1,
                "is_unverifiable_sku": false,
                "outOfStockStatus": 0,
                "quantity_ordered": 1,
                "customer_sku_id": 11492
              },
              {
                "product": "849806005822",
                "vor_reference_number": "4031436",
                "quantity": 1,
                "description": "10515 FOUR LOKO CAMO 12/23.5 CAN",
                "packages_per_case": 1,
                "is_unverifiable_sku": false,
                "outOfStockStatus": 0,
                "quantity_ordered": 1,
                "customer_sku_id": 21971
              },
              {
                "product": "018200250002",
                "vor_reference_number": "100837",
                "quantity": 3,
                "description": "Budweiser 15/25 Can",
                "packages_per_case": 1,
                "is_unverifiable_sku": false,
                "outOfStockStatus": 0,
                "quantity_ordered": 3,
                "customer_sku_id": 2612
              },
              {
                "product": "684746385104",
                "vor_reference_number": "402151",
                "quantity": 1,
                "description": "4306 JOHNY BOOTLEGGER SOUR APPLE 24/200 BOTTLE",
                "packages_per_case": 1,
                "is_unverifiable_sku": false,
                "outOfStockStatus": 0,
                "quantity_ordered": 1,
                "customer_sku_id": 5588
              },
              {
                "product": "684746375105",
                "vor_reference_number": "402377",
                "quantity": 2,
                "description": "2996 JOHNY BOOTLEGGER SOUR GRAPE 24/200 BOTTLE",
                "packages_per_case": 1,
                "is_unverifiable_sku": false,
                "outOfStockStatus": 0,
                "quantity_ordered": 2,
                "customer_sku_id": 5787
              },
              {
                "product": "01854325",
                "vor_reference_number": "402169",
                "quantity": 1,
                "description": "529 BUSCH LIGHT 6/4/16 CAN",
                "packages_per_case": 1,
                "is_unverifiable_sku": true,
                "outOfStockStatus": 0,
                "quantity_ordered": 1,
                "customer_sku_id": 5606
              },
              {
                "product": "018200005442",
                "vor_reference_number": "100118",
                "quantity": 2,
                "description": "Natural Light 6/4/16 Can",
                "packages_per_case": 1,
                "is_unverifiable_sku": true,
                "outOfStockStatus": 0,
                "quantity_ordered": 2,
                "customer_sku_id": 2964
              },
              {
                "product": "01852424",
                "vor_reference_number": "402143",
                "quantity": 4,
                "description": "314 ULTRA 6/4/16 CAN",
                "packages_per_case": 1,
                "is_unverifiable_sku": true,
                "outOfStockStatus": 0,
                "quantity_ordered": 4,
                "customer_sku_id": 5580
              },
              {
                "product": "01853821",
                "vor_reference_number": "402120",
                "quantity": 5,
                "description": "198 BUD LIGHT 6/4/16 CAN",
                "packages_per_case": 1,
                "is_unverifiable_sku": true,
                "outOfStockStatus": 0,
                "quantity_ordered": 5,
                "customer_sku_id": 5557
              },
              {
                "product": "018200250125",
                "vor_reference_number": "100584",
                "quantity": 1,
                "description": "Hurricane High Gravity 15/25 Can",
                "packages_per_case": 1,
                "is_unverifiable_sku": true,
                "outOfStockStatus": 0,
                "quantity_ordered": 1,
                "customer_sku_id": 2815
              },
              {
                "product": "018200008665",
                "vor_reference_number": "402128",
                "quantity": 2,
                "description": "2476 BUD LIGHT CHELADA 6/4/16 CAN",
                "packages_per_case": 1,
                "is_unverifiable_sku": true,
                "outOfStockStatus": 0,
                "quantity_ordered": 2,
                "customer_sku_id": 5565
              },
              {
                "product": "684746404447",
                "vor_reference_number": "4034255",
                "quantity": 1,
                "description": "10732 CLUBTAILS BLACK CHERRY BREEZE 24/16 CAN",
                "packages_per_case": 1,
                "is_unverifiable_sku": true,
                "outOfStockStatus": 0,
                "quantity_ordered": 1,
                "customer_sku_id": 24898
              },
              {
                "product": "684746401750",
                "vor_reference_number": "4067907",
                "quantity": 1,
                "description": "11231 CLUBTAILS HAPPY HOUR VARIETY PACK 2/12/12 CAN",
                "packages_per_case": 1,
                "is_unverifiable_sku": true,
                "outOfStockStatus": 0,
                "quantity_ordered": 1,
                "customer_sku_id": 66327
              }
            ],
            "validationStatus": {
              "status": "SUCCESS",
              "skuCountStatus": true,
              "skuStatus": true,
              "packageTypeStatus": true,
              "skuCount": 40,
              "picklistId": "6806148",
              "picklistSkuCount": 40,
              "contains_unverifiable_skus": true,
              "isWrapperPaused": false,
              "isRFIDNotPresent": false,
              "contains_untrained_skus": true,
              "isFullPallet": false,
              "rfid": null,
              "is_rfid_read_success": "FALSE",
              "is_lv_mapping_success": "FALSE",
              "is_rfid_reader_disconnected": true
            },
            "weightValidation": {
              "expected_weight": 1026.05,
              "actual_weight": 1029,
              "threshold_actual_weight": 11.1,
              "over_threshold_factor": 3,
              "delta": 2.95,
              "status": "TRUE",
              "unit": "lb",
              "vor_weight": 796.75,
              "vor_weight_delta": -229.3,
              "expected_weight_before_modification": 1026.05
            },
            "untrainedSkus": [
              {
                "upc": "684746401750",
                "vor_reference_number": "4067907"
              }
            ]
          }
        },
        "camera_images_urls": {
          "back": "https://vor-dev-adams-data-bucket.s3.amazonaws.com/Birmingham%20DC/Birmingham_W2/2026-01-22/SHANS%205567/6806148/2026-01-21_08_53_37/camera_images/6806148_2026-01-21_08_53_37_B.jpg?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=ASIAXMPEVCHYXWH35R2G%2F20260223%2Fus-east-2%2Fs3%2Faws4_request&X-Amz-Date=20260223T125648Z&X-Amz-Expires=3600&X-Amz-SignedHeaders=host&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEBQaCXVzLXdlc3QtMiJGMEQCIBXIpwpc2X0lpYo1doIdviPxSqAcdbXe%2FCB5wVenJK%2FqAiBMOCr6ZkNvMPQLZGwHF86aUpUG4C1Bbi6lUh2rm57PPCqXAwjd%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAMaDDUwNzgyMjU0MzM0NSIMbDvYc%2B7eGYjV42MJKusCjlXC3VJVKxFkc0u1wFrhmKZsZabLSpPaHI7bHZOZIcrr%2B9r7pfWlIYQjzechSdVKWNi%2BcuCNNGiFC%2FV1ysjHsIiylTJsnnkiz5ChIYQEFDx%2FPB%2F5cS%2FQ1myby4cwVBKCf8J2OiNR4zw99plo4xx2z0HOHVy3N4rBop1NXtRnxnbAdE82ihrLkGbwA6Pol%2FrXdhLfPUjDJJvPCqH1Gga7tD9uJYvOFMwQsaHvFrR9kvFcjImZX0MDpnuBN4oAfNfFakKKKVbpjOyirqmvr41pw4QtHi4pJje3NU1iFlIkJMtUbVOh4GUJG8gH2Fm41CCnZAiAZMcd0bkV8HynIvikPLKBoR0eZP14LZVEJ61Laso1Ne9nSzDmCEJWppIgYIOALNRXmuBa%2BLKJBgMmuoTOdv3VBSjAX5w9zYBdvbyErIMhfZ6J7U4diehbM9zpMWBc%2Ba77dYMEJH3n7hNNiMYGgpDZg8Sl%2BQaH6TZxMPmG8cwGOqUBVlKTab8bBekFHLVohfj0GVErY%2FvpC2OBnBO0CzWblKgWlfImEMTiiLKFzCKQBJrIr7duV9vSfEiP%2FcZ%2B2ODrBusYdNxT0gUwtQQ0gqH16WYo91EhL%2FJs9%2FtEpnK5aNtsoHXQAQFnm0LxvMUicYq2VwNBfPV%2BZMm0A8bJYF5veJ47LqzbpF0sx77DpbvjjcTy4FuMSg8ie92wkv7LaNuAgPa5WHof&X-Amz-Signature=11f95fa10d38ffd87a074a5362a0c98eba5c936b017dda4bacde68178b8f2596",
          "front": "https://vor-dev-adams-data-bucket.s3.amazonaws.com/Birmingham%20DC/Birmingham_W2/2026-01-22/SHANS%205567/6806148/2026-01-21_08_53_37/camera_images/6806148_2026-01-21_08_53_37_F.jpg?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=ASIAXMPEVCHYXWH35R2G%2F20260223%2Fus-east-2%2Fs3%2Faws4_request&X-Amz-Date=20260223T125648Z&X-Amz-Expires=3600&X-Amz-SignedHeaders=host&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEBQaCXVzLXdlc3QtMiJGMEQCIBXIpwpc2X0lpYo1doIdviPxSqAcdbXe%2FCB5wVenJK%2FqAiBMOCr6ZkNvMPQLZGwHF86aUpUG4C1Bbi6lUh2rm57PPCqXAwjd%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAMaDDUwNzgyMjU0MzM0NSIMbDvYc%2B7eGYjV42MJKusCjlXC3VJVKxFkc0u1wFrhmKZsZabLSpPaHI7bHZOZIcrr%2B9r7pfWlIYQjzechSdVKWNi%2BcuCNNGiFC%2FV1ysjHsIiylTJsnnkiz5ChIYQEFDx%2FPB%2F5cS%2FQ1myby4cwVBKCf8J2OiNR4zw99plo4xx2z0HOHVy3N4rBop1NXtRnxnbAdE82ihrLkGbwA6Pol%2FrXdhLfPUjDJJvPCqH1Gga7tD9uJYvOFMwQsaHvFrR9kvFcjImZX0MDpnuBN4oAfNfFakKKKVbpjOyirqmvr41pw4QtHi4pJje3NU1iFlIkJMtUbVOh4GUJG8gH2Fm41CCnZAiAZMcd0bkV8HynIvikPLKBoR0eZP14LZVEJ61Laso1Ne9nSzDmCEJWppIgYIOALNRXmuBa%2BLKJBgMmuoTOdv3VBSjAX5w9zYBdvbyErIMhfZ6J7U4diehbM9zpMWBc%2Ba77dYMEJH3n7hNNiMYGgpDZg8Sl%2BQaH6TZxMPmG8cwGOqUBVlKTab8bBekFHLVohfj0GVErY%2FvpC2OBnBO0CzWblKgWlfImEMTiiLKFzCKQBJrIr7duV9vSfEiP%2FcZ%2B2ODrBusYdNxT0gUwtQQ0gqH16WYo91EhL%2FJs9%2FtEpnK5aNtsoHXQAQFnm0LxvMUicYq2VwNBfPV%2BZMm0A8bJYF5veJ47LqzbpF0sx77DpbvjjcTy4FuMSg8ie92wkv7LaNuAgPa5WHof&X-Amz-Signature=35b6cfad4b86bc514f22f65461d3bfa8d6d4243cec644b06eb1e8e12da463727",
          "left": "https://vor-dev-adams-data-bucket.s3.amazonaws.com/Birmingham%20DC/Birmingham_W2/2026-01-22/SHANS%205567/6806148/2026-01-21_08_53_37/camera_images/6806148_2026-01-21_08_53_37_L.jpg?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=ASIAXMPEVCHYXWH35R2G%2F20260223%2Fus-east-2%2Fs3%2Faws4_request&X-Amz-Date=20260223T125648Z&X-Amz-Expires=3600&X-Amz-SignedHeaders=host&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEBQaCXVzLXdlc3QtMiJGMEQCIBXIpwpc2X0lpYo1doIdviPxSqAcdbXe%2FCB5wVenJK%2FqAiBMOCr6ZkNvMPQLZGwHF86aUpUG4C1Bbi6lUh2rm57PPCqXAwjd%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAMaDDUwNzgyMjU0MzM0NSIMbDvYc%2B7eGYjV42MJKusCjlXC3VJVKxFkc0u1wFrhmKZsZabLSpPaHI7bHZOZIcrr%2B9r7pfWlIYQjzechSdVKWNi%2BcuCNNGiFC%2FV1ysjHsIiylTJsnnkiz5ChIYQEFDx%2FPB%2F5cS%2FQ1myby4cwVBKCf8J2OiNR4zw99plo4xx2z0HOHVy3N4rBop1NXtRnxnbAdE82ihrLkGbwA6Pol%2FrXdhLfPUjDJJvPCqH1Gga7tD9uJYvOFMwQsaHvFrR9kvFcjImZX0MDpnuBN4oAfNfFakKKKVbpjOyirqmvr41pw4QtHi4pJje3NU1iFlIkJMtUbVOh4GUJG8gH2Fm41CCnZAiAZMcd0bkV8HynIvikPLKBoR0eZP14LZVEJ61Laso1Ne9nSzDmCEJWppIgYIOALNRXmuBa%2BLKJBgMmuoTOdv3VBSjAX5w9zYBdvbyErIMhfZ6J7U4diehbM9zpMWBc%2Ba77dYMEJH3n7hNNiMYGgpDZg8Sl%2BQaH6TZxMPmG8cwGOqUBVlKTab8bBekFHLVohfj0GVErY%2FvpC2OBnBO0CzWblKgWlfImEMTiiLKFzCKQBJrIr7duV9vSfEiP%2FcZ%2B2ODrBusYdNxT0gUwtQQ0gqH16WYo91EhL%2FJs9%2FtEpnK5aNtsoHXQAQFnm0LxvMUicYq2VwNBfPV%2BZMm0A8bJYF5veJ47LqzbpF0sx77DpbvjjcTy4FuMSg8ie92wkv7LaNuAgPa5WHof&X-Amz-Signature=6b45550e22fc37822a4d9b40352082283afc43ec93a54298bcbbfe9241e91e1c",
          "right": "https://vor-dev-adams-data-bucket.s3.amazonaws.com/Birmingham%20DC/Birmingham_W2/2026-01-22/SHANS%205567/6806148/2026-01-21_08_53_37/camera_images/6806148_2026-01-21_08_53_37_R.jpg?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=ASIAXMPEVCHYXWH35R2G%2F20260223%2Fus-east-2%2Fs3%2Faws4_request&X-Amz-Date=20260223T125648Z&X-Amz-Expires=3600&X-Amz-SignedHeaders=host&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEBQaCXVzLXdlc3QtMiJGMEQCIBXIpwpc2X0lpYo1doIdviPxSqAcdbXe%2FCB5wVenJK%2FqAiBMOCr6ZkNvMPQLZGwHF86aUpUG4C1Bbi6lUh2rm57PPCqXAwjd%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAMaDDUwNzgyMjU0MzM0NSIMbDvYc%2B7eGYjV42MJKusCjlXC3VJVKxFkc0u1wFrhmKZsZabLSpPaHI7bHZOZIcrr%2B9r7pfWlIYQjzechSdVKWNi%2BcuCNNGiFC%2FV1ysjHsIiylTJsnnkiz5ChIYQEFDx%2FPB%2F5cS%2FQ1myby4cwVBKCf8J2OiNR4zw99plo4xx2z0HOHVy3N4rBop1NXtRnxnbAdE82ihrLkGbwA6Pol%2FrXdhLfPUjDJJvPCqH1Gga7tD9uJYvOFMwQsaHvFrR9kvFcjImZX0MDpnuBN4oAfNfFakKKKVbpjOyirqmvr41pw4QtHi4pJje3NU1iFlIkJMtUbVOh4GUJG8gH2Fm41CCnZAiAZMcd0bkV8HynIvikPLKBoR0eZP14LZVEJ61Laso1Ne9nSzDmCEJWppIgYIOALNRXmuBa%2BLKJBgMmuoTOdv3VBSjAX5w9zYBdvbyErIMhfZ6J7U4diehbM9zpMWBc%2Ba77dYMEJH3n7hNNiMYGgpDZg8Sl%2BQaH6TZxMPmG8cwGOqUBVlKTab8bBekFHLVohfj0GVErY%2FvpC2OBnBO0CzWblKgWlfImEMTiiLKFzCKQBJrIr7duV9vSfEiP%2FcZ%2B2ODrBusYdNxT0gUwtQQ0gqH16WYo91EhL%2FJs9%2FtEpnK5aNtsoHXQAQFnm0LxvMUicYq2VwNBfPV%2BZMm0A8bJYF5veJ47LqzbpF0sx77DpbvjjcTy4FuMSg8ie92wkv7LaNuAgPa5WHof&X-Amz-Signature=c3736a6ec8516faa8a1a7ccb6720826adb86385ffaa5b96df439709493aac687"
        },
        "thumbnail_urls": {
          "back": "https://vor-dev-adams-data-bucket.s3.amazonaws.com/Birmingham%20DC/Birmingham_W2/2026-01-22/SHANS%205567/6806148/2026-01-21_08_53_37/thumbnails/6806148_2026-01-21_08_53_37_B.jpg?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=ASIAXMPEVCHYXWH35R2G%2F20260223%2Fus-east-2%2Fs3%2Faws4_request&X-Amz-Date=20260223T125648Z&X-Amz-Expires=3600&X-Amz-SignedHeaders=host&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEBQaCXVzLXdlc3QtMiJGMEQCIBXIpwpc2X0lpYo1doIdviPxSqAcdbXe%2FCB5wVenJK%2FqAiBMOCr6ZkNvMPQLZGwHF86aUpUG4C1Bbi6lUh2rm57PPCqXAwjd%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAMaDDUwNzgyMjU0MzM0NSIMbDvYc%2B7eGYjV42MJKusCjlXC3VJVKxFkc0u1wFrhmKZsZabLSpPaHI7bHZOZIcrr%2B9r7pfWlIYQjzechSdVKWNi%2BcuCNNGiFC%2FV1ysjHsIiylTJsnnkiz5ChIYQEFDx%2FPB%2F5cS%2FQ1myby4cwVBKCf8J2OiNR4zw99plo4xx2z0HOHVy3N4rBop1NXtRnxnbAdE82ihrLkGbwA6Pol%2FrXdhLfPUjDJJvPCqH1Gga7tD9uJYvOFMwQsaHvFrR9kvFcjImZX0MDpnuBN4oAfNfFakKKKVbpjOyirqmvr41pw4QtHi4pJje3NU1iFlIkJMtUbVOh4GUJG8gH2Fm41CCnZAiAZMcd0bkV8HynIvikPLKBoR0eZP14LZVEJ61Laso1Ne9nSzDmCEJWppIgYIOALNRXmuBa%2BLKJBgMmuoTOdv3VBSjAX5w9zYBdvbyErIMhfZ6J7U4diehbM9zpMWBc%2Ba77dYMEJH3n7hNNiMYGgpDZg8Sl%2BQaH6TZxMPmG8cwGOqUBVlKTab8bBekFHLVohfj0GVErY%2FvpC2OBnBO0CzWblKgWlfImEMTiiLKFzCKQBJrIr7duV9vSfEiP%2FcZ%2B2ODrBusYdNxT0gUwtQQ0gqH16WYo91EhL%2FJs9%2FtEpnK5aNtsoHXQAQFnm0LxvMUicYq2VwNBfPV%2BZMm0A8bJYF5veJ47LqzbpF0sx77DpbvjjcTy4FuMSg8ie92wkv7LaNuAgPa5WHof&X-Amz-Signature=c035d3c49c36f3c51226d56c8f76016af7291461ff3f14e9b48e4b1f31cfeabc",
          "front": "https://vor-dev-adams-data-bucket.s3.amazonaws.com/Birmingham%20DC/Birmingham_W2/2026-01-22/SHANS%205567/6806148/2026-01-21_08_53_37/thumbnails/6806148_2026-01-21_08_53_37_F.jpg?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=ASIAXMPEVCHYXWH35R2G%2F20260223%2Fus-east-2%2Fs3%2Faws4_request&X-Amz-Date=20260223T125648Z&X-Amz-Expires=3600&X-Amz-SignedHeaders=host&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEBQaCXVzLXdlc3QtMiJGMEQCIBXIpwpc2X0lpYo1doIdviPxSqAcdbXe%2FCB5wVenJK%2FqAiBMOCr6ZkNvMPQLZGwHF86aUpUG4C1Bbi6lUh2rm57PPCqXAwjd%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAMaDDUwNzgyMjU0MzM0NSIMbDvYc%2B7eGYjV42MJKusCjlXC3VJVKxFkc0u1wFrhmKZsZabLSpPaHI7bHZOZIcrr%2B9r7pfWlIYQjzechSdVKWNi%2BcuCNNGiFC%2FV1ysjHsIiylTJsnnkiz5ChIYQEFDx%2FPB%2F5cS%2FQ1myby4cwVBKCf8J2OiNR4zw99plo4xx2z0HOHVy3N4rBop1NXtRnxnbAdE82ihrLkGbwA6Pol%2FrXdhLfPUjDJJvPCqH1Gga7tD9uJYvOFMwQsaHvFrR9kvFcjImZX0MDpnuBN4oAfNfFakKKKVbpjOyirqmvr41pw4QtHi4pJje3NU1iFlIkJMtUbVOh4GUJG8gH2Fm41CCnZAiAZMcd0bkV8HynIvikPLKBoR0eZP14LZVEJ61Laso1Ne9nSzDmCEJWppIgYIOALNRXmuBa%2BLKJBgMmuoTOdv3VBSjAX5w9zYBdvbyErIMhfZ6J7U4diehbM9zpMWBc%2Ba77dYMEJH3n7hNNiMYGgpDZg8Sl%2BQaH6TZxMPmG8cwGOqUBVlKTab8bBekFHLVohfj0GVErY%2FvpC2OBnBO0CzWblKgWlfImEMTiiLKFzCKQBJrIr7duV9vSfEiP%2FcZ%2B2ODrBusYdNxT0gUwtQQ0gqH16WYo91EhL%2FJs9%2FtEpnK5aNtsoHXQAQFnm0LxvMUicYq2VwNBfPV%2BZMm0A8bJYF5veJ47LqzbpF0sx77DpbvjjcTy4FuMSg8ie92wkv7LaNuAgPa5WHof&X-Amz-Signature=b4fb763480c99a3c626d69c0fe214bea24ec9fa85cb62d021b3db8490d6a1195",
          "left": "https://vor-dev-adams-data-bucket.s3.amazonaws.com/Birmingham%20DC/Birmingham_W2/2026-01-22/SHANS%205567/6806148/2026-01-21_08_53_37/thumbnails/6806148_2026-01-21_08_53_37_L.jpg?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=ASIAXMPEVCHYXWH35R2G%2F20260223%2Fus-east-2%2Fs3%2Faws4_request&X-Amz-Date=20260223T125648Z&X-Amz-Expires=3600&X-Amz-SignedHeaders=host&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEBQaCXVzLXdlc3QtMiJGMEQCIBXIpwpc2X0lpYo1doIdviPxSqAcdbXe%2FCB5wVenJK%2FqAiBMOCr6ZkNvMPQLZGwHF86aUpUG4C1Bbi6lUh2rm57PPCqXAwjd%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAMaDDUwNzgyMjU0MzM0NSIMbDvYc%2B7eGYjV42MJKusCjlXC3VJVKxFkc0u1wFrhmKZsZabLSpPaHI7bHZOZIcrr%2B9r7pfWlIYQjzechSdVKWNi%2BcuCNNGiFC%2FV1ysjHsIiylTJsnnkiz5ChIYQEFDx%2FPB%2F5cS%2FQ1myby4cwVBKCf8J2OiNR4zw99plo4xx2z0HOHVy3N4rBop1NXtRnxnbAdE82ihrLkGbwA6Pol%2FrXdhLfPUjDJJvPCqH1Gga7tD9uJYvOFMwQsaHvFrR9kvFcjImZX0MDpnuBN4oAfNfFakKKKVbpjOyirqmvr41pw4QtHi4pJje3NU1iFlIkJMtUbVOh4GUJG8gH2Fm41CCnZAiAZMcd0bkV8HynIvikPLKBoR0eZP14LZVEJ61Laso1Ne9nSzDmCEJWppIgYIOALNRXmuBa%2BLKJBgMmuoTOdv3VBSjAX5w9zYBdvbyErIMhfZ6J7U4diehbM9zpMWBc%2Ba77dYMEJH3n7hNNiMYGgpDZg8Sl%2BQaH6TZxMPmG8cwGOqUBVlKTab8bBekFHLVohfj0GVErY%2FvpC2OBnBO0CzWblKgWlfImEMTiiLKFzCKQBJrIr7duV9vSfEiP%2FcZ%2B2ODrBusYdNxT0gUwtQQ0gqH16WYo91EhL%2FJs9%2FtEpnK5aNtsoHXQAQFnm0LxvMUicYq2VwNBfPV%2BZMm0A8bJYF5veJ47LqzbpF0sx77DpbvjjcTy4FuMSg8ie92wkv7LaNuAgPa5WHof&X-Amz-Signature=d00a7b5e5d7c796de3da7cc74029b5ce7f4cbce71ee7ad82a707bfebd24ff3bf",
          "right": "https://vor-dev-adams-data-bucket.s3.amazonaws.com/Birmingham%20DC/Birmingham_W2/2026-01-22/SHANS%205567/6806148/2026-01-21_08_53_37/thumbnails/6806148_2026-01-21_08_53_37_R.jpg?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=ASIAXMPEVCHYXWH35R2G%2F20260223%2Fus-east-2%2Fs3%2Faws4_request&X-Amz-Date=20260223T125648Z&X-Amz-Expires=3600&X-Amz-SignedHeaders=host&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEBQaCXVzLXdlc3QtMiJGMEQCIBXIpwpc2X0lpYo1doIdviPxSqAcdbXe%2FCB5wVenJK%2FqAiBMOCr6ZkNvMPQLZGwHF86aUpUG4C1Bbi6lUh2rm57PPCqXAwjd%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAMaDDUwNzgyMjU0MzM0NSIMbDvYc%2B7eGYjV42MJKusCjlXC3VJVKxFkc0u1wFrhmKZsZabLSpPaHI7bHZOZIcrr%2B9r7pfWlIYQjzechSdVKWNi%2BcuCNNGiFC%2FV1ysjHsIiylTJsnnkiz5ChIYQEFDx%2FPB%2F5cS%2FQ1myby4cwVBKCf8J2OiNR4zw99plo4xx2z0HOHVy3N4rBop1NXtRnxnbAdE82ihrLkGbwA6Pol%2FrXdhLfPUjDJJvPCqH1Gga7tD9uJYvOFMwQsaHvFrR9kvFcjImZX0MDpnuBN4oAfNfFakKKKVbpjOyirqmvr41pw4QtHi4pJje3NU1iFlIkJMtUbVOh4GUJG8gH2Fm41CCnZAiAZMcd0bkV8HynIvikPLKBoR0eZP14LZVEJ61Laso1Ne9nSzDmCEJWppIgYIOALNRXmuBa%2BLKJBgMmuoTOdv3VBSjAX5w9zYBdvbyErIMhfZ6J7U4diehbM9zpMWBc%2Ba77dYMEJH3n7hNNiMYGgpDZg8Sl%2BQaH6TZxMPmG8cwGOqUBVlKTab8bBekFHLVohfj0GVErY%2FvpC2OBnBO0CzWblKgWlfImEMTiiLKFzCKQBJrIr7duV9vSfEiP%2FcZ%2B2ODrBusYdNxT0gUwtQQ0gqH16WYo91EhL%2FJs9%2FtEpnK5aNtsoHXQAQFnm0LxvMUicYq2VwNBfPV%2BZMm0A8bJYF5veJ47LqzbpF0sx77DpbvjjcTy4FuMSg8ie92wkv7LaNuAgPa5WHof&X-Amz-Signature=6ffc94740fcbc6cb87eb3ff949d39d7c16d3be7112a402f477e6488142f030cc"
        },
        "6806148_2026-01-21_08_53_37_F": {
          "annotation": {
            "folder": "realsense_F.jpg",
            "filename": "realsense_F.jpg",
            "path": "output/realsense/realsense_F.jpg",
            "source": {
              "database": "Unknown"
            },
            "size": {
              "width": "2160",
              "height": "3264",
              "depth": "3"
            },
            "segmented": "0",
            "object": [
              {
                "name": "402120_Side",
                "pose": "18",
                "truncated": "0",
                "difficult": "0",
                "bndbox": {
                  "xmin": "1057",
                  "ymin": "2239",
                  "xmax": "1676",
                  "ymax": "2535"
                }
              },
              {
                "name": "402120_End",
                "pose": "23",
                "truncated": "0",
                "difficult": "0",
                "bndbox": {
                  "xmin": "671",
                  "ymin": "2216",
                  "xmax": "1059",
                  "ymax": "2493"
                }
              },
              {
                "name": "402261_End",
                "pose": "2",
                "truncated": "0",
                "difficult": "0",
                "bndbox": {
                  "xmin": "299",
                  "ymin": "2197",
                  "xmax": "670",
                  "ymax": "2465"
                }
              },
              {
                "name": "100118_Side",
                "pose": "19",
                "truncated": "0",
                "difficult": "0",
                "bndbox": {
                  "xmin": "1060",
                  "ymin": "2006",
                  "xmax": "1681",
                  "ymax": "2242"
                }
              },
              {
                "name": "402148_End",
                "pose": "24",
                "truncated": "0",
                "difficult": "0",
                "bndbox": {
                  "xmin": "670",
                  "ymin": "1988",
                  "xmax": "1060",
                  "ymax": "2218"
                }
              },
              {
                "name": "402143_End",
                "pose": "3",
                "truncated": "0",
                "difficult": "0",
                "bndbox": {
                  "xmin": "295",
                  "ymin": "1969",
                  "xmax": "668",
                  "ymax": "2199"
                }
              },
              {
                "name": "402143_Side",
                "pose": "20",
                "truncated": "0",
                "difficult": "0",
                "bndbox": {
                  "xmin": "1064",
                  "ymin": "1760",
                  "xmax": "1684",
                  "ymax": "2010"
                }
              },
              {
                "name": "400545_End",
                "pose": "25",
                "truncated": "0",
                "difficult": "0",
                "bndbox": {
                  "xmin": "668",
                  "ymin": "1759",
                  "xmax": "1064",
                  "ymax": "1991"
                }
              },
              {
                "name": "402244_End",
                "pose": "4",
                "truncated": "0",
                "difficult": "0",
                "bndbox": {
                  "xmin": "290",
                  "ymin": "1748",
                  "xmax": "667",
                  "ymax": "1971"
                }
              },
              {
                "name": "4031436_Side",
                "pose": "21",
                "truncated": "0",
                "difficult": "0",
                "bndbox": {
                  "xmin": "1077",
                  "ymin": "1472",
                  "xmax": "1581",
                  "ymax": "1763"
                }
              },
              {
                "name": "402375_End",
                "pose": "26",
                "truncated": "0",
                "difficult": "0",
                "bndbox": {
                  "xmin": "719",
                  "ymin": "1523",
                  "xmax": "1071",
                  "ymax": "1760"
                }
              },
              {
                "name": "402151_Side",
                "pose": "5",
                "truncated": "0",
                "difficult": "0",
                "bndbox": {
                  "xmin": "274",
                  "ymin": "1515",
                  "xmax": "718",
                  "ymax": "1752"
                }
              },
              {
                "name": "402375_End",
                "pose": "27",
                "truncated": "0",
                "difficult": "0",
                "bndbox": {
                  "xmin": "725",
                  "ymin": "1261",
                  "xmax": "1060",
                  "ymax": "1525"
                }
              },
              {
                "name": "100837_Side",
                "pose": "6",
                "truncated": "0",
                "difficult": "0",
                "bndbox": {
                  "xmin": "197",
                  "ymin": "1217",
                  "xmax": "727",
                  "ymax": "1517"
                }
              },
              {
                "name": "100855_Side",
                "pose": "22",
                "truncated": "0",
                "difficult": "0",
                "bndbox": {
                  "xmin": "1058",
                  "ymin": "1125",
                  "xmax": "1637",
                  "ymax": "1476"
                }
              },
              {
                "name": "100819_Side",
                "pose": "7",
                "truncated": "0",
                "difficult": "0",
                "bndbox": {
                  "xmin": "225",
                  "ymin": "887",
                  "xmax": "787",
                  "ymax": "1220"
                }
              }
            ]
          }
        },
        "6806148_2026-01-21_08_53_37_B": {
          "annotation": {
            "folder": "realsense_B.jpg",
            "filename": "realsense_B.jpg",
            "path": "output/realsense/realsense_B.jpg",
            "source": {
              "database": "Unknown"
            },
            "size": {
              "width": "2160",
              "height": "3264",
              "depth": "3"
            },
            "segmented": "0",
            "object": [
              {
                "name": "402261_End",
                "pose": "2",
                "truncated": "0",
                "difficult": "0",
                "bndbox": {
                  "xmin": "1390",
                  "ymin": "2179",
                  "xmax": "1791",
                  "ymax": "2445"
                }
              },
              {
                "name": "402120_Side",
                "pose": "13",
                "truncated": "0",
                "difficult": "0",
                "bndbox": {
                  "xmin": "470",
                  "ymin": "2151",
                  "xmax": "1012",
                  "ymax": "2432"
                }
              },
              {
                "name": "402120_End",
                "pose": "23",
                "truncated": "0",
                "difficult": "0",
                "bndbox": {
                  "xmin": "1010",
                  "ymin": "2165",
                  "xmax": "1392",
                  "ymax": "2429"
                }
              },
              {
                "name": "402143_End",
                "pose": "3",
                "truncated": "0",
                "difficult": "0",
                "bndbox": {
                  "xmin": "1401",
                  "ymin": "1937",
                  "xmax": "1806",
                  "ymax": "2181"
                }
              },
              {
                "name": "402148_End",
                "pose": "24",
                "truncated": "0",
                "difficult": "0",
                "bndbox": {
                  "xmin": "1021",
                  "ymin": "1942",
                  "xmax": "1401",
                  "ymax": "2167"
                }
              },
              {
                "name": "402128_Side",
                "pose": "14",
                "truncated": "0",
                "difficult": "0",
                "bndbox": {
                  "xmin": "478",
                  "ymin": "1943",
                  "xmax": "1021",
                  "ymax": "2155"
                }
              },
              {
                "name": "400545_Side",
                "pose": "15",
                "truncated": "0",
                "difficult": "0",
                "bndbox": {
                  "xmin": "462",
                  "ymin": "1696",
                  "xmax": "1020",
                  "ymax": "1947"
                }
              },
              {
                "name": "1844961_End",
                "pose": "28",
                "truncated": "0",
                "difficult": "0",
                "bndbox": {
                  "xmin": "1019",
                  "ymin": "1710",
                  "xmax": "1400",
                  "ymax": "1945"
                }
              },
              {
                "name": "402244_End",
                "pose": "4",
                "truncated": "0",
                "difficult": "0",
                "bndbox": {
                  "xmin": "1401",
                  "ymin": "1708",
                  "xmax": "1761",
                  "ymax": "1939"
                }
              },
              {
                "name": "405094_End",
                "pose": "29",
                "truncated": "0",
                "difficult": "0",
                "bndbox": {
                  "xmin": "1068",
                  "ymin": "1439",
                  "xmax": "1373",
                  "ymax": "1713"
                }
              },
              {
                "name": "402151_Side",
                "pose": "8",
                "truncated": "0",
                "difficult": "0",
                "bndbox": {
                  "xmin": "1374",
                  "ymin": "1488",
                  "xmax": "1810",
                  "ymax": "1709"
                }
              },
              {
                "name": "101012_Side",
                "pose": "16",
                "truncated": "0",
                "difficult": "0",
                "bndbox": {
                  "xmin": "603",
                  "ymin": "1427",
                  "xmax": "1069",
                  "ymax": "1700"
                }
              },
              {
                "name": "100837_Side",
                "pose": "9",
                "truncated": "0",
                "difficult": "0",
                "bndbox": {
                  "xmin": "1371",
                  "ymin": "1224",
                  "xmax": "1879",
                  "ymax": "1492"
                }
              },
              {
                "name": "101012_End",
                "pose": "30",
                "truncated": "0",
                "difficult": "0",
                "bndbox": {
                  "xmin": "1070",
                  "ymin": "1157",
                  "xmax": "1369",
                  "ymax": "1441"
                }
              },
              {
                "name": "101015_Side",
                "pose": "17",
                "truncated": "0",
                "difficult": "0",
                "bndbox": {
                  "xmin": "586",
                  "ymin": "1132",
                  "xmax": "1072",
                  "ymax": "1431"
                }
              },
              {
                "name": "100812_Side",
                "pose": "10",
                "truncated": "0",
                "difficult": "0",
                "bndbox": {
                  "xmin": "1369",
                  "ymin": "925",
                  "xmax": "1886",
                  "ymax": "1227"
                }
              }
            ]
          }
        },
        "6806148_2026-01-21_08_53_37_L": {
          "annotation": {
            "folder": "realsense_L.jpg",
            "filename": "realsense_L.jpg",
            "path": "output/realsense/realsense_L.jpg",
            "source": {
              "database": "Unknown"
            },
            "size": {
              "width": "2160",
              "height": "3264",
              "depth": "3"
            },
            "segmented": "0",
            "object": [
              {
                "name": "402261_Side",
                "pose": "2",
                "truncated": "0",
                "difficult": "0",
                "bndbox": {
                  "xmin": "1084",
                  "ymin": "2286",
                  "xmax": "1741",
                  "ymax": "2595"
                }
              },
              {
                "name": "402143_Side",
                "pose": "3",
                "truncated": "0",
                "difficult": "0",
                "bndbox": {
                  "xmin": "1087",
                  "ymin": "2037",
                  "xmax": "1736",
                  "ymax": "2288"
                }
              },
              {
                "name": "402244_Side",
                "pose": "4",
                "truncated": "0",
                "difficult": "0",
                "bndbox": {
                  "xmin": "1099",
                  "ymin": "1798",
                  "xmax": "1748",
                  "ymax": "2039"
                }
              },
              {
                "name": "402151_End",
                "pose": "5",
                "truncated": "0",
                "difficult": "0",
                "bndbox": {
                  "xmin": "1370",
                  "ymin": "1547",
                  "xmax": "1760",
                  "ymax": "1800"
                }
              },
              {
                "name": "402377_End",
                "pose": "1",
                "truncated": "0",
                "difficult": "0",
                "bndbox": {
                  "xmin": "1018",
                  "ymin": "1540",
                  "xmax": "1370",
                  "ymax": "1788"
                }
              },
              {
                "name": "402151_End",
                "pose": "8",
                "truncated": "0",
                "difficult": "0",
                "bndbox": {
                  "xmin": "663",
                  "ymin": "1533",
                  "xmax": "1018",
                  "ymax": "1787"
                }
              },
              {
                "name": "100837_End",
                "pose": "6",
                "truncated": "0",
                "difficult": "0",
                "bndbox": {
                  "xmin": "1029",
                  "ymin": "1215",
                  "xmax": "1391",
                  "ymax": "1541"
                }
              },
              {
                "name": "100837_End",
                "pose": "9",
                "truncated": "0",
                "difficult": "0",
                "bndbox": {
                  "xmin": "669",
                  "ymin": "1216",
                  "xmax": "1030",
                  "ymax": "1534"
                }
              },
              {
                "name": "100812_End",
                "pose": "10",
                "truncated": "0",
                "difficult": "0",
                "bndbox": {
                  "xmin": "673",
                  "ymin": "880",
                  "xmax": "1030",
                  "ymax": "1216"
                }
              },
              {
                "name": "100819_End",
                "pose": "7",
                "truncated": "0",
                "difficult": "0",
                "bndbox": {
                  "xmin": "1029",
                  "ymin": "869",
                  "xmax": "1393",
                  "ymax": "1214"
                }
              }
            ]
          }
        },
        "6806148_2026-01-21_08_53_37_R": {
          "annotation": {
            "folder": "realsense_R.jpg",
            "filename": "realsense_R.jpg",
            "path": "output/realsense/realsense_R.jpg",
            "source": {
              "database": "Unknown"
            },
            "size": {
              "width": "2160",
              "height": "3264",
              "depth": "3"
            },
            "segmented": "0",
            "object": [
              {
                "name": "402120_End",
                "pose": "13",
                "truncated": "0",
                "difficult": "0",
                "bndbox": {
                  "xmin": "799",
                  "ymin": "2203",
                  "xmax": "1175",
                  "ymax": "2478"
                }
              },
              {
                "name": "402120_End",
                "pose": "18",
                "truncated": "0",
                "difficult": "0",
                "bndbox": {
                  "xmin": "428",
                  "ymin": "2188",
                  "xmax": "799",
                  "ymax": "2452"
                }
              },
              {
                "name": "402128_End",
                "pose": "14",
                "truncated": "0",
                "difficult": "0",
                "bndbox": {
                  "xmin": "799",
                  "ymin": "1982",
                  "xmax": "1176",
                  "ymax": "2204"
                }
              },
              {
                "name": "100118_End",
                "pose": "19",
                "truncated": "0",
                "difficult": "0",
                "bndbox": {
                  "xmin": "420",
                  "ymin": "1965",
                  "xmax": "796",
                  "ymax": "2189"
                }
              },
              {
                "name": "400545_End",
                "pose": "15",
                "truncated": "0",
                "difficult": "0",
                "bndbox": {
                  "xmin": "796",
                  "ymin": "1734",
                  "xmax": "1182",
                  "ymax": "1983"
                }
              },
              {
                "name": "402143_End",
                "pose": "20",
                "truncated": "0",
                "difficult": "0",
                "bndbox": {
                  "xmin": "420",
                  "ymin": "1730",
                  "xmax": "797",
                  "ymax": "1966"
                }
              },
              {
                "name": "101012_End",
                "pose": "16",
                "truncated": "0",
                "difficult": "0",
                "bndbox": {
                  "xmin": "1064",
                  "ymin": "1447",
                  "xmax": "1408",
                  "ymax": "1735"
                }
              },
              {
                "name": "100110_End",
                "pose": "11",
                "truncated": "0",
                "difficult": "0",
                "bndbox": {
                  "xmin": "758",
                  "ymin": "1447",
                  "xmax": "1064",
                  "ymax": "1731"
                }
              },
              {
                "name": "4031436_End",
                "pose": "21",
                "truncated": "0",
                "difficult": "0",
                "bndbox": {
                  "xmin": "449",
                  "ymin": "1453",
                  "xmax": "759",
                  "ymax": "1730"
                }
              },
              {
                "name": "100855_End",
                "pose": "22",
                "truncated": "0",
                "difficult": "0",
                "bndbox": {
                  "xmin": "433",
                  "ymin": "1163",
                  "xmax": "740",
                  "ymax": "1454"
                }
              },
              {
                "name": "101015_End",
                "pose": "17",
                "truncated": "0",
                "difficult": "0",
                "bndbox": {
                  "xmin": "1054",
                  "ymin": "1157",
                  "xmax": "1393",
                  "ymax": "1447"
                }
              },
              {
                "name": "100824_End",
                "pose": "12",
                "truncated": "0",
                "difficult": "0",
                "bndbox": {
                  "xmin": "740",
                  "ymin": "1161",
                  "xmax": "1055",
                  "ymax": "1447"
                }
              }
            ]
          }
        },
        "inference_result": {
          "inference_id": 2729930,
          "pallet_type": "Rehrig Duo",
          "expected_case_count": 40,
          "actual_case_count": 40,
          "exp_weight": 1026.05,
          "act_weight": 1029,
          "is_verified_success": true,
          "skus": [
            {
              "vor_reference_number": "100819",
              "description": "Bud Ice 15/25 Can",
              "quantity_ordered": 1,
              "customer_sku_id": 2525
            },
            {
              "vor_reference_number": "101012",
              "description": "Bud Light 15/25 Can",
              "quantity_ordered": 2,
              "customer_sku_id": 2535
            },
            {
              "vor_reference_number": "100812",
              "description": "Bud Light Chelada 15/25 Can",
              "quantity_ordered": 1,
              "customer_sku_id": 2550
            },
            {
              "vor_reference_number": "100110",
              "description": "Busch Light 15/25 Can",
              "quantity_ordered": 1,
              "customer_sku_id": 2635
            },
            {
              "vor_reference_number": "100824",
              "description": "Natural Ice 15/25 Can",
              "quantity_ordered": 1,
              "customer_sku_id": 2951
            },
            {
              "vor_reference_number": "100855",
              "description": "Natural Light 15/25 Can",
              "quantity_ordered": 1,
              "customer_sku_id": 2955
            },
            {
              "vor_reference_number": "101015",
              "description": "Ultra 15/25 Can",
              "quantity_ordered": 1,
              "customer_sku_id": 3136
            },
            {
              "vor_reference_number": "400545",
              "description": "375 ULTRA 3/8/16 CAN",
              "quantity_ordered": 2,
              "customer_sku_id": 3982
            },
            {
              "vor_reference_number": "402148",
              "description": "3842 HURRICANE HIGH GRAVITY 6/4/16 CAN",
              "quantity_ordered": 1,
              "customer_sku_id": 5585
            },
            {
              "vor_reference_number": "402261",
              "description": "91 BUDWEISER 6/4/16 CAN",
              "quantity_ordered": 1,
              "customer_sku_id": 5698
            },
            {
              "vor_reference_number": "402375",
              "description": "2998 JOHNY BOOTLEGGER RASPBERRY 24/200 BOTTLE",
              "quantity_ordered": 2,
              "customer_sku_id": 5785
            },
            {
              "vor_reference_number": "405094",
              "description": "9769 FOUR LOKO SOUR BLUE RAZZ 12/23.5 CAN",
              "quantity_ordered": 1,
              "customer_sku_id": 8417
            },
            {
              "vor_reference_number": "1844961",
              "description": "10098 CLUBTAILS GRAPE ESCAPE 24/16 CAN",
              "quantity_ordered": 1,
              "customer_sku_id": 11492
            },
            {
              "vor_reference_number": "4031436",
              "description": "10515 FOUR LOKO CAMO 12/23.5 CAN",
              "quantity_ordered": 1,
              "customer_sku_id": 21971
            },
            {
              "vor_reference_number": "100837",
              "description": "Budweiser 15/25 Can",
              "quantity_ordered": 3,
              "customer_sku_id": 2612
            },
            {
              "vor_reference_number": "402151",
              "description": "4306 JOHNY BOOTLEGGER SOUR APPLE 24/200 BOTTLE",
              "quantity_ordered": 1,
              "customer_sku_id": 5588
            },
            {
              "vor_reference_number": "402377",
              "description": "2996 JOHNY BOOTLEGGER SOUR GRAPE 24/200 BOTTLE",
              "quantity_ordered": 2,
              "customer_sku_id": 5787
            },
            {
              "vor_reference_number": "402169",
              "description": "529 BUSCH LIGHT 6/4/16 CAN",
              "quantity_ordered": 1,
              "customer_sku_id": 5606
            },
            {
              "vor_reference_number": "100118",
              "description": "Natural Light 6/4/16 Can",
              "quantity_ordered": 2,
              "customer_sku_id": 2964
            },
            {
              "vor_reference_number": "402143",
              "description": "314 ULTRA 6/4/16 CAN",
              "quantity_ordered": 4,
              "customer_sku_id": 5580
            },
            {
              "vor_reference_number": "402120",
              "description": "198 BUD LIGHT 6/4/16 CAN",
              "quantity_ordered": 5,
              "customer_sku_id": 5557
            },
            {
              "vor_reference_number": "100584",
              "description": "Hurricane High Gravity 15/25 Can",
              "quantity_ordered": 1,
              "customer_sku_id": 2815
            },
            {
              "vor_reference_number": "402128",
              "description": "2476 BUD LIGHT CHELADA 6/4/16 CAN",
              "quantity_ordered": 2,
              "customer_sku_id": 5565
            },
            {
              "vor_reference_number": "4034255",
              "description": "10732 CLUBTAILS BLACK CHERRY BREEZE 24/16 CAN",
              "quantity_ordered": 1,
              "customer_sku_id": 24898
            },
            {
              "vor_reference_number": "4067907",
              "description": "11231 CLUBTAILS HAPPY HOUR VARIETY PACK 2/12/12 CAN",
              "quantity_ordered": 1,
              "customer_sku_id": 66327
            }
          ]
        }
      }

    static WORK_ITEMS = {
        "data": [
          {
            "manual_labeled_pallet_id": 36,
            "customer_id": 11,
            "dc_id": 6,
            "customer_picklist_id": "89859981",
            "delivery_date": "2025-11-25",
            "s3_url": "s3://vor-qa-adams-data-bucket/Pollocksville DC/RTCQA_D/2025-11-25/Loves 16001/89859981/2025-11-24_12_49_28",
            "status": "NEW",
            "priority": 10,
            "is_system_recommended": true,
            "is_llm_labeled": false,
            "is_modified_after_llm_labeled": false,
            "labeled_by": "Admin analyst",
            "label_completion_date": null,
            "reviewed_by": "Admin",
            "review_completion_date": null,
            "creation_date": "2026-02-20T13:53:58.190000",
            "created_by": "Admin analyst",
            "last_updated_date": "2026-02-20T13:53:58.190000",
            "last_updated_by": "Admin analyst"
          },
          {
            "manual_labeled_pallet_id": 35,
            "customer_id": 11,
            "dc_id": 6,
            "customer_picklist_id": "4117452",
            "delivery_date": "2025-12-01",
            "s3_url": "s3://vor-qa-adams-data-bucket/Pollocksville DC/RTCQA_D/2025-12-01/ADAMS VIP STORE 9 7283789/4117452/2025-11-24_18_11_11",
            "status": "NEW",
            "priority": 10,
            "is_system_recommended": true,
            "is_llm_labeled": false,
            "is_modified_after_llm_labeled": false,
            "labeled_by": "Admin analyst",
            "label_completion_date": null,
            "reviewed_by": "Admin",
            "review_completion_date": null,
            "creation_date": "2026-02-20T13:53:58.173000",
            "created_by": "Admin analyst",
            "last_updated_date": "2026-02-20T13:53:58.173000",
            "last_updated_by": "Admin analyst"
          },
          {
            "manual_labeled_pallet_id": 34,
            "customer_id": 11,
            "dc_id": 6,
            "customer_picklist_id": "1412011",
            "delivery_date": "2025-11-27",
            "s3_url": "s3://vor-qa-adams-data-bucket/Pollocksville DC/RTCQA_D/2025-11-27/Loves 16001/1412011/2025-11-26_15_14_44",
            "status": "NEW",
            "priority": 10,
            "is_system_recommended": true,
            "is_llm_labeled": false,
            "is_modified_after_llm_labeled": false,
            "labeled_by": "Admin analyst",
            "label_completion_date": null,
            "reviewed_by": "Admin",
            "review_completion_date": null,
            "creation_date": "2026-02-20T13:53:58.157000",
            "created_by": "Admin analyst",
            "last_updated_date": "2026-02-20T13:53:58.157000",
            "last_updated_by": "Admin analyst"
          },
          {
            "manual_labeled_pallet_id": 33,
            "customer_id": 11,
            "dc_id": 6,
            "customer_picklist_id": "1412012",
            "delivery_date": "2025-11-27",
            "s3_url": "s3://vor-qa-adams-data-bucket/Pollocksville DC/RTCQA_D/2025-11-27/Loves 16001/1412012/2025-11-26_15_15_54",
            "status": "NEW",
            "priority": 10,
            "is_system_recommended": true,
            "is_llm_labeled": false,
            "is_modified_after_llm_labeled": false,
            "labeled_by": "Admin analyst",
            "label_completion_date": null,
            "reviewed_by": "Admin",
            "review_completion_date": null,
            "creation_date": "2026-02-20T13:53:58.147000",
            "created_by": "Admin analyst",
            "last_updated_date": "2026-02-20T13:53:58.147000",
            "last_updated_by": "Admin analyst"
          },
          {
            "manual_labeled_pallet_id": 32,
            "customer_id": 11,
            "dc_id": 6,
            "customer_picklist_id": "1119106",
            "delivery_date": "2026-01-15",
            "s3_url": "s3://vor-qa-adams-data-bucket/Pollocksville DC/RTCQA_D/2026-01-15/Shell 16002/1119106/2026-01-14_14_21_46",
            "status": "NEW",
            "priority": 10,
            "is_system_recommended": true,
            "is_llm_labeled": false,
            "is_modified_after_llm_labeled": false,
            "labeled_by": "Admin analyst",
            "label_completion_date": null,
            "reviewed_by": "Admin",
            "review_completion_date": null,
            "creation_date": "2026-02-20T13:53:58.140000",
            "created_by": "Admin analyst",
            "last_updated_date": "2026-02-20T13:53:58.140000",
            "last_updated_by": "Admin analyst"
          },
          {
            "manual_labeled_pallet_id": 31,
            "customer_id": 11,
            "dc_id": 6,
            "customer_picklist_id": "1119107",
            "delivery_date": "2026-01-15",
            "s3_url": "s3://vor-qa-adams-data-bucket/Pollocksville DC/RTCQA_D/2026-01-15/Shell 16002/1119107/2026-01-14_14_23_25",
            "status": "NEW",
            "priority": 10,
            "is_system_recommended": true,
            "is_llm_labeled": false,
            "is_modified_after_llm_labeled": false,
            "labeled_by": "Admin analyst",
            "label_completion_date": null,
            "reviewed_by": "Admin",
            "review_completion_date": null,
            "creation_date": "2026-02-20T13:53:58.130000",
            "created_by": "Admin analyst",
            "last_updated_date": "2026-02-20T13:53:58.130000",
            "last_updated_by": "Admin analyst"
          },
          {
            "manual_labeled_pallet_id": 30,
            "customer_id": 11,
            "dc_id": 6,
            "customer_picklist_id": "1119108",
            "delivery_date": "2026-01-15",
            "s3_url": "s3://vor-qa-adams-data-bucket/Pollocksville DC/RTCQA_D/2026-01-15/Shell 16002/1119108/2026-01-14_14_24_55",
            "status": "NEW",
            "priority": 10,
            "is_system_recommended": true,
            "is_llm_labeled": false,
            "is_modified_after_llm_labeled": false,
            "labeled_by": "Admin analyst",
            "label_completion_date": null,
            "reviewed_by": "Admin",
            "review_completion_date": null,
            "creation_date": "2026-02-20T13:53:58.120000",
            "created_by": "Admin analyst",
            "last_updated_date": "2026-02-20T13:53:58.120000",
            "last_updated_by": "Admin analyst"
          },
          {
            "manual_labeled_pallet_id": 29,
            "customer_id": 11,
            "dc_id": 6,
            "customer_picklist_id": "1119109",
            "delivery_date": "2026-01-15",
            "s3_url": "s3://vor-qa-adams-data-bucket/Pollocksville DC/RTCQA_D/2026-01-15/Shell 16002/1119109/2026-01-14_14_33_08",
            "status": "NEW",
            "priority": 10,
            "is_system_recommended": true,
            "is_llm_labeled": false,
            "is_modified_after_llm_labeled": false,
            "labeled_by": "Admin analyst",
            "label_completion_date": null,
            "reviewed_by": "Admin",
            "review_completion_date": null,
            "creation_date": "2026-02-20T13:53:58.113000",
            "created_by": "Admin analyst",
            "last_updated_date": "2026-02-20T13:53:58.113000",
            "last_updated_by": "Admin analyst"
          },
          {
            "manual_labeled_pallet_id": 28,
            "customer_id": 11,
            "dc_id": 6,
            "customer_picklist_id": "1119110",
            "delivery_date": "2026-01-15",
            "s3_url": "s3://vor-qa-adams-data-bucket/Pollocksville DC/RTCQA_D/2026-01-15/Shell 16002/1119110/2026-01-14_14_37_14",
            "status": "NEW",
            "priority": 10,
            "is_system_recommended": true,
            "is_llm_labeled": false,
            "is_modified_after_llm_labeled": false,
            "labeled_by": "Admin analyst",
            "label_completion_date": null,
            "reviewed_by": "Admin",
            "review_completion_date": null,
            "creation_date": "2026-02-20T13:53:58.103000",
            "created_by": "Admin analyst",
            "last_updated_date": "2026-02-20T13:53:58.103000",
            "last_updated_by": "Admin analyst"
          },
          {
            "manual_labeled_pallet_id": 27,
            "customer_id": 11,
            "dc_id": 6,
            "customer_picklist_id": "1119111",
            "delivery_date": "2026-01-15",
            "s3_url": "s3://vor-qa-adams-data-bucket/Pollocksville DC/RTCQA_D/2026-01-15/Shell 16002/1119111/2026-01-14_14_45_00",
            "status": "NEW",
            "priority": 10,
            "is_system_recommended": true,
            "is_llm_labeled": false,
            "is_modified_after_llm_labeled": false,
            "labeled_by": "Admin analyst",
            "label_completion_date": null,
            "reviewed_by": "Admin",
            "review_completion_date": null,
            "creation_date": "2026-02-20T13:53:58.090000",
            "created_by": "Admin analyst",
            "last_updated_date": "2026-02-20T13:53:58.090000",
            "last_updated_by": "Admin analyst"
          },
          {
            "manual_labeled_pallet_id": 26,
            "customer_id": 11,
            "dc_id": 6,
            "customer_picklist_id": "1119112",
            "delivery_date": "2026-01-15",
            "s3_url": "s3://vor-qa-adams-data-bucket/Pollocksville DC/RTCQA_D/2026-01-15/Shell 16002/1119112/2026-01-14_14_48_01",
            "status": "NEW",
            "priority": 10,
            "is_system_recommended": true,
            "is_llm_labeled": false,
            "is_modified_after_llm_labeled": false,
            "labeled_by": "Admin analyst",
            "label_completion_date": null,
            "reviewed_by": "Admin",
            "review_completion_date": null,
            "creation_date": "2026-02-20T13:53:58.077000",
            "created_by": "Admin analyst",
            "last_updated_date": "2026-02-20T13:53:58.077000",
            "last_updated_by": "Admin analyst"
          },
          {
            "manual_labeled_pallet_id": 25,
            "customer_id": 11,
            "dc_id": 6,
            "customer_picklist_id": "1119114",
            "delivery_date": "2026-01-15",
            "s3_url": "s3://vor-qa-adams-data-bucket/Pollocksville DC/RTCQA_D/2026-01-15/Shell 16002/1119114/2026-01-14_14_54_06",
            "status": "NEW",
            "priority": 10,
            "is_system_recommended": true,
            "is_llm_labeled": false,
            "is_modified_after_llm_labeled": false,
            "labeled_by": "Admin analyst",
            "label_completion_date": null,
            "reviewed_by": "Admin",
            "review_completion_date": null,
            "creation_date": "2026-02-20T13:53:58.070000",
            "created_by": "Admin analyst",
            "last_updated_date": "2026-02-20T13:53:58.070000",
            "last_updated_by": "Admin analyst"
          },
          {
            "manual_labeled_pallet_id": 24,
            "customer_id": 11,
            "dc_id": 6,
            "customer_picklist_id": "1119115",
            "delivery_date": "2026-01-15",
            "s3_url": "s3://vor-qa-adams-data-bucket/Pollocksville DC/RTCQA_D/2026-01-15/Shell 16002/1119115/2026-01-14_15_10_11",
            "status": "NEW",
            "priority": 10,
            "is_system_recommended": true,
            "is_llm_labeled": false,
            "is_modified_after_llm_labeled": false,
            "labeled_by": "Admin analyst",
            "label_completion_date": null,
            "reviewed_by": "Admin",
            "review_completion_date": null,
            "creation_date": "2026-02-20T13:53:58.060000",
            "created_by": "Admin analyst",
            "last_updated_date": "2026-02-20T13:53:58.060000",
            "last_updated_by": "Admin analyst"
          },
          {
            "manual_labeled_pallet_id": 23,
            "customer_id": 11,
            "dc_id": 6,
            "customer_picklist_id": "1119117",
            "delivery_date": "2026-01-15",
            "s3_url": "s3://vor-qa-adams-data-bucket/Pollocksville DC/RTCQA_D/2026-01-15/Shell 16002/1119117/2026-01-14_15_14_35",
            "status": "NEW",
            "priority": 10,
            "is_system_recommended": true,
            "is_llm_labeled": false,
            "is_modified_after_llm_labeled": false,
            "labeled_by": "Admin analyst",
            "label_completion_date": null,
            "reviewed_by": "Admin",
            "review_completion_date": null,
            "creation_date": "2026-02-20T13:53:58.050000",
            "created_by": "Admin analyst",
            "last_updated_date": "2026-02-20T13:53:58.050000",
            "last_updated_by": "Admin analyst"
          },
          {
            "manual_labeled_pallet_id": 22,
            "customer_id": 11,
            "dc_id": 6,
            "customer_picklist_id": "1119119",
            "delivery_date": "2026-01-15",
            "s3_url": "s3://vor-qa-adams-data-bucket/Pollocksville DC/RTCQA_D/2026-01-15/Shell 16002/1119119/2026-01-14_15_18_55",
            "status": "NEW",
            "priority": 10,
            "is_system_recommended": true,
            "is_llm_labeled": false,
            "is_modified_after_llm_labeled": false,
            "labeled_by": "Admin analyst",
            "label_completion_date": null,
            "reviewed_by": "Admin",
            "review_completion_date": null,
            "creation_date": "2026-02-20T13:53:58.043000",
            "created_by": "Admin analyst",
            "last_updated_date": "2026-02-20T13:53:58.043000",
            "last_updated_by": "Admin analyst"
          },
          {
            "manual_labeled_pallet_id": 21,
            "customer_id": 11,
            "dc_id": 6,
            "customer_picklist_id": "202601191",
            "delivery_date": "2026-01-19",
            "s3_url": "s3://vor-qa-adams-data-bucket/Pollocksville DC/RTCQA_D/2026-01-19/Loves 16001/202601191/2026-01-18_22_44_44",
            "status": "NEW",
            "priority": 10,
            "is_system_recommended": true,
            "is_llm_labeled": false,
            "is_modified_after_llm_labeled": false,
            "labeled_by": "Admin analyst",
            "label_completion_date": null,
            "reviewed_by": "Admin",
            "review_completion_date": null,
            "creation_date": "2026-02-20T13:53:58.033000",
            "created_by": "Admin analyst",
            "last_updated_date": "2026-02-20T13:53:58.033000",
            "last_updated_by": "Admin analyst"
          },
          {
            "manual_labeled_pallet_id": 20,
            "customer_id": 11,
            "dc_id": 6,
            "customer_picklist_id": "26011901",
            "delivery_date": "2026-01-19",
            "s3_url": "s3://vor-qa-adams-data-bucket/Pollocksville DC/RTCQA_D/2026-01-19/Loves 16001/26011901/2026-01-18_23_15_34",
            "status": "NEW",
            "priority": 10,
            "is_system_recommended": true,
            "is_llm_labeled": false,
            "is_modified_after_llm_labeled": false,
            "labeled_by": "Admin analyst",
            "label_completion_date": null,
            "reviewed_by": "Admin",
            "review_completion_date": null,
            "creation_date": "2026-02-20T13:53:58.007000",
            "created_by": "Admin analyst",
            "last_updated_date": "2026-02-20T13:53:58.007000",
            "last_updated_by": "Admin analyst"
          },
          {
            "manual_labeled_pallet_id": 19,
            "customer_id": 11,
            "dc_id": 6,
            "customer_picklist_id": "372701",
            "delivery_date": "2026-01-23",
            "s3_url": "s3://vor-qa-adams-data-bucket/Pollocksville DC/RTCQA_D/2026-01-23/Loves 16001/372701/2026-01-22_11_57_56",
            "status": "NEW",
            "priority": 10,
            "is_system_recommended": true,
            "is_llm_labeled": false,
            "is_modified_after_llm_labeled": false,
            "labeled_by": "Admin analyst",
            "label_completion_date": null,
            "reviewed_by": "Admin",
            "review_completion_date": null,
            "creation_date": "2026-02-20T13:53:57.993000",
            "created_by": "Admin analyst",
            "last_updated_date": "2026-02-20T13:53:57.993000",
            "last_updated_by": "Admin analyst"
          },
          {
            "manual_labeled_pallet_id": 18,
            "customer_id": 11,
            "dc_id": 6,
            "customer_picklist_id": "372702",
            "delivery_date": "2026-01-23",
            "s3_url": "s3://vor-qa-adams-data-bucket/Pollocksville DC/RTCQA_D/2026-01-23/Loves 16001/372702/2026-01-22_11_58_50",
            "status": "NEW",
            "priority": 10,
            "is_system_recommended": true,
            "is_llm_labeled": false,
            "is_modified_after_llm_labeled": false,
            "labeled_by": "Admin analyst",
            "label_completion_date": null,
            "reviewed_by": "Admin",
            "review_completion_date": null,
            "creation_date": "2026-02-20T13:53:57.983000",
            "created_by": "Admin analyst",
            "last_updated_date": "2026-02-20T13:53:57.983000",
            "last_updated_by": "Admin analyst"
          },
          {
            "manual_labeled_pallet_id": 17,
            "customer_id": 11,
            "dc_id": 6,
            "customer_picklist_id": "26012701",
            "delivery_date": "2026-01-27",
            "s3_url": "s3://vor-qa-adams-data-bucket/Pollocksville DC/RTCQA_D/2026-01-27/Loves 16001/26012701/2026-01-27_10_42_09",
            "status": "NEW",
            "priority": 10,
            "is_system_recommended": true,
            "is_llm_labeled": false,
            "is_modified_after_llm_labeled": false,
            "labeled_by": "Admin analyst",
            "label_completion_date": null,
            "reviewed_by": "Admin",
            "review_completion_date": null,
            "creation_date": "2026-02-20T13:53:57.970000",
            "created_by": "Admin analyst",
            "last_updated_date": "2026-02-20T13:53:57.970000",
            "last_updated_by": "Admin analyst"
          },
          {
            "manual_labeled_pallet_id": 16,
            "customer_id": 11,
            "dc_id": 6,
            "customer_picklist_id": "26020601",
            "delivery_date": "2026-02-06",
            "s3_url": "s3://vor-qa-adams-data-bucket/Pollocksville DC/RTCQA_D/2026-02-06/Loves 16001/26020601/2026-02-06_01_35_14",
            "status": "NEW",
            "priority": 10,
            "is_system_recommended": true,
            "is_llm_labeled": false,
            "is_modified_after_llm_labeled": false,
            "labeled_by": "Admin analyst",
            "label_completion_date": null,
            "reviewed_by": "Admin",
            "review_completion_date": null,
            "creation_date": "2026-02-20T13:53:57.960000",
            "created_by": "Admin analyst",
            "last_updated_date": "2026-02-20T13:53:57.960000",
            "last_updated_by": "Admin analyst"
          },
          {
            "manual_labeled_pallet_id": 15,
            "customer_id": 11,
            "dc_id": 6,
            "customer_picklist_id": "26020904",
            "delivery_date": "2026-02-09",
            "s3_url": "s3://vor-qa-adams-data-bucket/Pollocksville DC/RTCQA_D/2026-02-09/Loves 16001/26020904/2026-02-09_10_07_29",
            "status": "NEW",
            "priority": 10,
            "is_system_recommended": true,
            "is_llm_labeled": false,
            "is_modified_after_llm_labeled": false,
            "labeled_by": "Admin analyst",
            "label_completion_date": null,
            "reviewed_by": "Admin",
            "review_completion_date": null,
            "creation_date": "2026-02-20T13:53:57.953000",
            "created_by": "Admin analyst",
            "last_updated_date": "2026-02-20T13:53:57.953000",
            "last_updated_by": "Admin analyst"
          },
          {
            "manual_labeled_pallet_id": 14,
            "customer_id": 11,
            "dc_id": 6,
            "customer_picklist_id": "3003036",
            "delivery_date": "2026-02-13",
            "s3_url": "s3://vor-qa-adams-data-bucket/Pollocksville DC/RTCQA_D/2026-02-13/Loves 16001/3003036/2026-02-09_15_21_34",
            "status": "NEW",
            "priority": 10,
            "is_system_recommended": true,
            "is_llm_labeled": false,
            "is_modified_after_llm_labeled": false,
            "labeled_by": "Admin analyst",
            "label_completion_date": null,
            "reviewed_by": "Admin",
            "review_completion_date": null,
            "creation_date": "2026-02-20T13:53:57.917000",
            "created_by": "Admin analyst",
            "last_updated_date": "2026-02-20T13:53:57.917000",
            "last_updated_by": "Admin analyst"
          },
          {
            "manual_labeled_pallet_id": 13,
            "customer_id": 11,
            "dc_id": 6,
            "customer_picklist_id": "3003037",
            "delivery_date": "2026-02-13",
            "s3_url": "s3://vor-qa-adams-data-bucket/Pollocksville DC/RTCQA_D/2026-02-13/Loves 16001/3003037/2026-02-09_15_24_22",
            "status": "NEW",
            "priority": 10,
            "is_system_recommended": true,
            "is_llm_labeled": false,
            "is_modified_after_llm_labeled": false,
            "labeled_by": "Admin analyst",
            "label_completion_date": null,
            "reviewed_by": "Admin",
            "review_completion_date": null,
            "creation_date": "2026-02-20T13:53:57.910000",
            "created_by": "Admin analyst",
            "last_updated_date": "2026-02-20T13:53:57.910000",
            "last_updated_by": "Admin analyst"
          },
          {
            "manual_labeled_pallet_id": 12,
            "customer_id": 11,
            "dc_id": 6,
            "customer_picklist_id": "3003038",
            "delivery_date": "2026-02-13",
            "s3_url": "s3://vor-qa-adams-data-bucket/Pollocksville DC/RTCQA_D/2026-02-13/Loves 16001/3003038/2026-02-09_15_25_35",
            "status": "NEW",
            "priority": 10,
            "is_system_recommended": true,
            "is_llm_labeled": false,
            "is_modified_after_llm_labeled": false,
            "labeled_by": "Admin analyst",
            "label_completion_date": null,
            "reviewed_by": "Admin",
            "review_completion_date": null,
            "creation_date": "2026-02-20T13:53:57.900000",
            "created_by": "Admin analyst",
            "last_updated_date": "2026-02-20T13:53:57.900000",
            "last_updated_by": "Admin analyst"
          },
          {
            "manual_labeled_pallet_id": 11,
            "customer_id": 11,
            "dc_id": 6,
            "customer_picklist_id": "3003039",
            "delivery_date": "2026-02-13",
            "s3_url": "s3://vor-qa-adams-data-bucket/Pollocksville DC/RTCQA_D/2026-02-13/Loves 16001/3003039/2026-02-09_15_27_47",
            "status": "NEW",
            "priority": 10,
            "is_system_recommended": true,
            "is_llm_labeled": false,
            "is_modified_after_llm_labeled": false,
            "labeled_by": "Admin analyst",
            "label_completion_date": null,
            "reviewed_by": "Admin",
            "review_completion_date": null,
            "creation_date": "2026-02-20T13:53:57.893000",
            "created_by": "Admin analyst",
            "last_updated_date": "2026-02-20T13:53:57.893000",
            "last_updated_by": "Admin analyst"
          },
          {
            "manual_labeled_pallet_id": 10,
            "customer_id": 11,
            "dc_id": 6,
            "customer_picklist_id": "3003040",
            "delivery_date": "2026-02-13",
            "s3_url": "s3://vor-qa-adams-data-bucket/Pollocksville DC/RTCQA_D/2026-02-13/Loves 16001/3003040/2026-02-09_15_28_29",
            "status": "NEW",
            "priority": 10,
            "is_system_recommended": true,
            "is_llm_labeled": false,
            "is_modified_after_llm_labeled": false,
            "labeled_by": "Admin analyst",
            "label_completion_date": null,
            "reviewed_by": "Admin",
            "review_completion_date": null,
            "creation_date": "2026-02-20T13:53:57.887000",
            "created_by": "Admin analyst",
            "last_updated_date": "2026-02-20T13:53:57.887000",
            "last_updated_by": "Admin analyst"
          },
          {
            "manual_labeled_pallet_id": 9,
            "customer_id": 11,
            "dc_id": 6,
            "customer_picklist_id": "3003076",
            "delivery_date": "2026-02-13",
            "s3_url": "s3://vor-qa-adams-data-bucket/Pollocksville DC/RTCQA_D/2026-02-13/Shell 16002/3003076/2026-02-09_17_08_41",
            "status": "NEW",
            "priority": 10,
            "is_system_recommended": true,
            "is_llm_labeled": false,
            "is_modified_after_llm_labeled": false,
            "labeled_by": "Admin analyst",
            "label_completion_date": null,
            "reviewed_by": "Admin",
            "review_completion_date": null,
            "creation_date": "2026-02-20T13:53:57.880000",
            "created_by": "Admin analyst",
            "last_updated_date": "2026-02-20T13:53:57.880000",
            "last_updated_by": "Admin analyst"
          },
          {
            "manual_labeled_pallet_id": 8,
            "customer_id": 11,
            "dc_id": 6,
            "customer_picklist_id": "3003077",
            "delivery_date": "2026-02-13",
            "s3_url": "s3://vor-qa-adams-data-bucket/Pollocksville DC/RTCQA_D/2026-02-13/Shell 16002/3003077/2026-02-09_17_13_08",
            "status": "NEW",
            "priority": 10,
            "is_system_recommended": true,
            "is_llm_labeled": false,
            "is_modified_after_llm_labeled": false,
            "labeled_by": "Admin analyst",
            "label_completion_date": null,
            "reviewed_by": "Admin",
            "review_completion_date": null,
            "creation_date": "2026-02-20T13:53:57.870000",
            "created_by": "Admin analyst",
            "last_updated_date": "2026-02-20T13:53:57.870000",
            "last_updated_by": "Admin analyst"
          },
          {
            "manual_labeled_pallet_id": 7,
            "customer_id": 11,
            "dc_id": 6,
            "customer_picklist_id": "3003078",
            "delivery_date": "2026-02-13",
            "s3_url": "s3://vor-qa-adams-data-bucket/Pollocksville DC/RTCQA_D/2026-02-13/Shell 16002/3003078/2026-02-09_17_13_58",
            "status": "NEW",
            "priority": 10,
            "is_system_recommended": true,
            "is_llm_labeled": false,
            "is_modified_after_llm_labeled": false,
            "labeled_by": "Admin analyst",
            "label_completion_date": null,
            "reviewed_by": "Admin",
            "review_completion_date": null,
            "creation_date": "2026-02-20T13:53:57.860000",
            "created_by": "Admin analyst",
            "last_updated_date": "2026-02-20T13:53:57.860000",
            "last_updated_by": "Admin analyst"
          },
          {
            "manual_labeled_pallet_id": 6,
            "customer_id": 11,
            "dc_id": 6,
            "customer_picklist_id": "3003079",
            "delivery_date": "2026-02-13",
            "s3_url": "s3://vor-qa-adams-data-bucket/Pollocksville DC/RTCQA_D/2026-02-13/Shell 16002/3003079/2026-02-09_17_14_56",
            "status": "NEW",
            "priority": 10,
            "is_system_recommended": true,
            "is_llm_labeled": false,
            "is_modified_after_llm_labeled": false,
            "labeled_by": "Admin analyst",
            "label_completion_date": null,
            "reviewed_by": "Admin",
            "review_completion_date": null,
            "creation_date": "2026-02-20T13:53:57.850000",
            "created_by": "Admin analyst",
            "last_updated_date": "2026-02-20T13:53:57.850000",
            "last_updated_by": "Admin analyst"
          },
          {
            "manual_labeled_pallet_id": 5,
            "customer_id": 11,
            "dc_id": 6,
            "customer_picklist_id": "3003080",
            "delivery_date": "2026-02-13",
            "s3_url": "s3://vor-qa-adams-data-bucket/Pollocksville DC/RTCQA_D/2026-02-13/Shell 16002/3003080/2026-02-09_17_16_18",
            "status": "NEW",
            "priority": 10,
            "is_system_recommended": true,
            "is_llm_labeled": false,
            "is_modified_after_llm_labeled": false,
            "labeled_by": "Admin analyst",
            "label_completion_date": null,
            "reviewed_by": "Admin",
            "review_completion_date": null,
            "creation_date": "2026-02-20T13:53:57.837000",
            "created_by": "Admin analyst",
            "last_updated_date": "2026-02-20T13:53:57.837000",
            "last_updated_by": "Admin analyst"
          },
          {
            "manual_labeled_pallet_id": 4,
            "customer_id": 11,
            "dc_id": 6,
            "customer_picklist_id": "7401426",
            "delivery_date": "2026-02-12",
            "s3_url": "s3://vor-qa-adams-data-bucket/Pollocksville DC/RTCQA_D/2026-02-12/Loves 16001/7401426/2026-02-10_15_49_08",
            "status": "NEW",
            "priority": 10,
            "is_system_recommended": true,
            "is_llm_labeled": false,
            "is_modified_after_llm_labeled": false,
            "labeled_by": "Admin analyst",
            "label_completion_date": null,
            "reviewed_by": "Admin",
            "review_completion_date": null,
            "creation_date": "2026-02-20T13:53:57.830000",
            "created_by": "Admin analyst",
            "last_updated_date": "2026-02-20T13:53:57.830000",
            "last_updated_by": "Admin analyst"
          },
          {
            "manual_labeled_pallet_id": 3,
            "customer_id": 11,
            "dc_id": 6,
            "customer_picklist_id": "7401427",
            "delivery_date": "2026-02-12",
            "s3_url": "s3://vor-qa-adams-data-bucket/Pollocksville DC/RTCQA_D/2026-02-12/Loves 16001/7401427/2026-02-10_15_50_00",
            "status": "NEW",
            "priority": 10,
            "is_system_recommended": true,
            "is_llm_labeled": false,
            "is_modified_after_llm_labeled": false,
            "labeled_by": "Admin analyst",
            "label_completion_date": null,
            "reviewed_by": "Admin",
            "review_completion_date": null,
            "creation_date": "2026-02-20T13:53:57.820000",
            "created_by": "Admin analyst",
            "last_updated_date": "2026-02-20T13:53:57.820000",
            "last_updated_by": "Admin analyst"
          },
          {
            "manual_labeled_pallet_id": 2,
            "customer_id": 11,
            "dc_id": 6,
            "customer_picklist_id": "7401428",
            "delivery_date": "2026-02-12",
            "s3_url": "s3://vor-qa-adams-data-bucket/Pollocksville DC/RTCQA_D/2026-02-12/Loves 16001/7401428/2026-02-10_15_50_39",
            "status": "NEW",
            "priority": 10,
            "is_system_recommended": true,
            "is_llm_labeled": false,
            "is_modified_after_llm_labeled": false,
            "labeled_by": "Admin analyst",
            "label_completion_date": null,
            "reviewed_by": "Admin",
            "review_completion_date": null,
            "creation_date": "2026-02-20T13:53:57.813000",
            "created_by": "Admin analyst",
            "last_updated_date": "2026-02-20T13:53:57.813000",
            "last_updated_by": "Admin analyst"
          },
          {
            "manual_labeled_pallet_id": 1,
            "customer_id": 11,
            "dc_id": 6,
            "customer_picklist_id": "7401429",
            "delivery_date": "2026-02-12",
            "s3_url": "s3://vor-qa-adams-data-bucket/Pollocksville DC/RTCQA_D/2026-02-12/Loves 16001/7401429/2026-02-10_15_51_28",
            "status": "NEW",
            "priority": 10,
            "is_system_recommended": true,
            "is_llm_labeled": false,
            "is_modified_after_llm_labeled": false,
            "labeled_by": "Admin analyst",
            "label_completion_date": null,
            "reviewed_by": "Admin",
            "review_completion_date": null,
            "creation_date": "2026-02-20T13:53:57.803000",
            "created_by": "Admin analyst",
            "last_updated_date": "2026-02-20T13:53:57.803000",
            "last_updated_by": "Admin analyst"
          }
        ],
        "metadata": {
          "total_count": 36,
          "page_number": 1,
          "page_size": 50,
          "total_pages": 1
        }
      }




    //static RPC_ADMIN = "RpcAdmin";
    //static RPC_READ_ONLY = "RpcReadOnly";

    static CUSTOMER_ADMIN = "CustomerAdmin";
    static LOCATION_ADMIN = "LocationAdmin";
    static LIFT_MAINTENANCE_EVENT = "LIFT_MAINTENANCE_EVENT";
    static LIFT_ADD_MAINTENANCE_EVENT = "LIFT_ADD_MAINTENANCE_EVENT";
    static STOP_SCAN_PALLET = "StopScanPallet";

    static SUCCESS = "success";
    static ERROR = "error";

    static DOOR_IN_PROGRESS = "InProgress";
    static DOOR_IN_OK = "Active";
    static DOOR_IN_ROUTE_CONFLICT = "Route Conflict";
    static DOOR_OUT_OF_SEQUENCE = "Out of sequence";


    static DOOR_IDLE = "Idle";
    static DOOR_FORCE_COMPLETED = "ForceCompleted";
    static DOOR_COMPLETED = "Completed";
    static DOOR_CLOSED = "Closed";

    static DOOR_UN_ASSIGNED = "Unassigned";
    static DOCK_DOOR_DC_ID = "";
    static DOCK_DOOR_CUST_ID= "";
    static LOADING_ERROR = "LOADING ERROR"
    static MANUALLY_CLOSED = "Manually Closed";
    static MANUAL = "Manual";
    static AUTO = "Auto";
    static OPEN = "Open";
    static REMOVED = "Removed";
    static OK = "OK"
    static MARK_FIXED = "Mark Fixed";
    static VIEW = "View";
    static SELECTED_ROW_INDEX = 0;
    static DOCK_DOOR_NAVIGATION_FROM = "";
    static DOCK_DOOR_SEARCH_BUTTON = "DOCK_DOOR_SEARCH_BUTTON";
    static DOCK_DOOR_PALLET_HISTORY = "DOCK_DOOR_PALLET_HISTORY";

   // static LOADING_SUCCESS = "Route Conflict"



    static  barcodeData = "";
    static IS_BARCODE_SCANNER_START = false;
    static  barcodes = []

    static EXPAND_COLLAPSE_PANEL = "";
    static PANEL1 = false;
    static PANEL2 = false;
    static PANEL3 = false;

    static PALLET_DETAILS = []

    static setScanBarcodes(barCode){
        Constants.barcodeData = barCode;
    }
    static clearBarcodes(){
        Constants.barcodeData = "";
        Constants.barcodes = []
    }
    static getBarcodes(){
        return Constants.barcodeData
    }




   // static locationId = ""
    //static customerId = "";

    static IS_PROGRESS_ENABLED = false;

    static DOORS_DATA = []
    static ROUTES_DATA = []



}
